/* N8KD P0 mobile UX remediation — pack selector whole-card tap target.
   Delegated click listener (not bound to elements at load time, so it works
   regardless of when the Qikify Volume app hydrates the pack-selector cards).
   Forwards a real .click() to the app's own reliably-clickable radio label,
   so the entire visible card acts as the touch target instead of only the
   ~20x20px radio circle. Native controls inside the card (the shade dropdown)
   are explicitly excluded so they keep their own default behavior. */
(function () {
  function onCardClick(e) {
    var card = e.target.closest && e.target.closest('.qvl-volume-tier');
    if (!card) return;

    var label = card.querySelector('.qvl-volume-tier__radio__label');
    if (!label || label.contains(e.target)) return;

    if (e.target.closest('select, option, a, button, textarea, input')) return;

    label.click();
  }

  document.addEventListener('click', onCardClick, true);
})();
